import React from "react";
import "./Dashboard.css";
import { StudentAdminMap } from "../Map/Map";


export const StudentAdminDashboard = () => {
  return (
    <div className="StudentAdminBody QuestMapCard InrPageTopBarMargin">
      <div className="container-fluid p-0 m-0">        
        <div>
          <StudentAdminMap />
        </div>
      </div>
    </div>
  );
};
